import React from 'react';
import { useTranslation } from 'react-i18next';
import SubscriptionInfoPresenter from 'presenters/SubscriptionInfoPresenter';
import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

const UpcomingInvoice = props => {
  const { subscriptionInfo } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h2" className={classes.header}>
        {t('components.SubscriptionPage.UpcomingInvoice.header')}
      </Typography>
      <div className={classes.charge}>
        <Typography variant="body1">{t('components.SubscriptionPage.UpcomingInvoice.charge')}</Typography>
        <Typography variant="body1" className={classes.chargeAmount}>
          {SubscriptionInfoPresenter.readableChargeAmount(subscriptionInfo)}
        </Typography>
      </div>
      <Typography variant="body2" color="secondary">
        {`${t('components.SubscriptionPage.UpcomingInvoice.willBeCharged')} ${SubscriptionInfoPresenter.nextChargeDate(
          subscriptionInfo,
        )}`}
      </Typography>
      <div className={classes.invoiceDescription}>
        <div>
          <Typography variant="subtitle1" color="secondary" className={classes.fieldTitle}>
            {t('components.SubscriptionPage.UpcomingInvoice.planTitle')}
          </Typography>
          <Typography variant="body1">{t('components.SubscriptionPage.UpcomingInvoice.basePlan')}</Typography>
        </div>
        <div className={classes.invoiceValues}>
          <div>
            <Typography variant="subtitle1" color="secondary" className={classes.fieldTitle}>
              {t('components.SubscriptionPage.UpcomingInvoice.connections')}
            </Typography>
            <Typography align="right" variant="body1">
              {SubscriptionInfoPresenter.connections(subscriptionInfo)}
            </Typography>
          </div>
          <div className={classes.invoiceAmount}>
            <Typography align="right" variant="subtitle1" color="secondary" className={classes.fieldTitle}>
              {t('components.SubscriptionPage.UpcomingInvoice.invoice')}
            </Typography>
            <Typography align="right" variant="body1">
              {SubscriptionInfoPresenter.readableInvoiceAmount(subscriptionInfo)}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

UpcomingInvoice.propTypes = {
  subscriptionInfo: SubscriptionInfoPresenter.shape().isRequired,
};

export default UpcomingInvoice;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/UpcomingInvoice/UpcomingInvoice.js